import { gql } from '@apollo/client';

export const insertEraCareNotificationDenyListItemMutation = gql`
  mutation ($object: era_care_notifications_deny_list_insert_input!) {
    insert_era_care_notifications_deny_list_one(object: $object) {
      era_care_notification_id
    }
  }
`;
